import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isMobile from 'is-mobile';
import ToggleSwitch from '../../ToggleSwitch';
import CalendarLabel from '../CalendarLabel';
import SingleCheckbox from '../../SingleCheckbox';
import CardBody from '../../CardBody';

export const isChecked = (cal, unChecked) =>
  !unChecked.find(u => u.id === cal.id);

const CalendarFilter = ({
  calendars,
  unChecked,
  onChange,
  onToggle,
  title,
  toggleSwitch,
  toggleChecked,
  toggleLabel,
  ...props
}) => (
  <Fragment>
    <CardBody style={{ width: isMobile() ? '100vw' : '' }} {...props}>
      <h3>{title}</h3>
      <ul className='pt-2x'>
        {/* TODO: Improve this implementation */}
        {calendars.map(cal => (
          <SingleCheckbox
            checked={isChecked(cal, unChecked)}
            name={toString(cal.id)}
            id={cal.id}
            onChange={(_, e) => onChange(e)}
            label={<CalendarLabel {...cal} />}
            key={cal.id}
            inputProps={{ value: cal.id }}
          />
        ))}
      </ul>
    </CardBody>
    {toggleSwitch && (
      <CardBody>
        <ToggleSwitch
          label={toggleLabel}
          name='CalendarFilterToggle'
          onChange={onToggle}
          isChecked={toggleChecked}
        />
      </CardBody>
    )}
  </Fragment>
);

CalendarFilter.defaultProps = {
  unChecked: [],
  toggleSwitch: false,
  toggleChecked: false
};

CalendarFilter.propTypes = {
  calendars: PropTypes.array.isRequired,
  unChecked: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  toggleSwitch: PropTypes.bool,
  toggleLabel: PropTypes.string,
  toggleChecked: PropTypes.bool,
  onToggle: PropTypes.func
};

export default CalendarFilter;
